// Structural data only — all human-readable copy lives in /lib/i18n.js
import {
  Award,
  Star,
  CreditCard,
  CalendarDays,
  Sparkles,
  Smartphone,
  Bell,
  ShieldCheck,
  BarChart3,
  Users,
  Globe,
  Zap,
  Send,
  ScanLine,
  Wallet,
  Building2,
  Repeat,
  Trophy,
  Target,
  Mail,
  Clock,
  CreditCard as PayCard,
  Layers,
  LinkIcon,
  Megaphone,
  PartyPopper,
  QrCode,
} from "lucide-react";

export const PRODUCTS = {
  loyalty: {
    slug: "loyalty",
    name: "TRYB Loyalty",
    accent: "loyalty",
    accentColor: "hsl(45, 93%, 47%)",
    accentGlow: "rgba(230, 180, 8, 0.35)",
    liveUrl: "https://www.trybloyalty.com",
    status: "live",
    icon: Award,
    statsValues: [
      { value: 3000, suffix: "+" },
      { value: 30, suffix: "%" },
      { value: 2, suffix: "x" },
      { value: 15, suffix: "" },
    ],
    featureIcons: [CreditCard, Bell, Smartphone, ScanLine, BarChart3, Zap],
    pricing: [
      { price: "€39", per: "/mo" },
      { price: "€69", per: "/mo" },
      { price: "€299", per: "/mo", featured: true },
      { price: "—", per: "" },
    ],
    mockups: {
      laptop:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/8u2ceev6_screenshot-%5Btrybloyalty.com%5D.webp",
      mobile:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/g3rkb5pf_WhatsApp%20Image%202026-05-14%20at%2011.27.52%20AM.jpeg",
    },
  },

  review: {
    slug: "review",
    name: "TRYB Review",
    accent: "review",
    accentColor: "hsl(270, 100%, 60%)",
    accentGlow: "rgba(153, 51, 255, 0.35)",
    liveUrl: "https://www.tryb.review",
    status: "live",
    icon: Star,
    statsValues: [
      { value: 1750, suffix: "+" },
      { value: 20, suffix: "+" },
      { value: 1, suffix: "" },
      { value: 100, suffix: "%" },
    ],
    featureIcons: [Send, ShieldCheck, Sparkles, Globe, Megaphone, BarChart3],
    pricing: [
      { price: "€49", per: "/mo" },
      { price: "€490", per: "/yr", featured: true },
      { price: "€2,500", per: "" },
    ],
    mockups: {
      laptop:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/191am4ap_screenshot-%5Bapp.tryb.review%5D.webp",
      mobile:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/pgh9y14t_screenshot-%5Bgo.tryb.review%5D.webp",
    },
  },

  connect: {
    slug: "connect",
    name: "TRYB Connect",
    accent: "connect",
    accentColor: "hsl(190, 100%, 50%)",
    accentGlow: "rgba(0, 255, 255, 0.35)",
    liveUrl: "https://tryb.ma",
    status: "live",
    icon: CreditCard,
    statsValues: [
      { value: 100, suffix: "%" },
      { value: 2, suffix: "" },
      { value: 100, suffix: "%" },
      { value: 24, suffix: "/7" },
    ],
    featureIcons: [Sparkles, Wallet, Repeat, BarChart3, Globe, Users],
    pricing: [
      { price: "€9.99", per: "/mo" },
      { price: "€19.99", per: "/mo", featured: true },
    ],
    mockups: {
      laptop:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/og57eob0_screenshot-%5Btryb%20connect%5D.webp",
      mobile:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/m7yj8zlm_tryb%20connect.jpeg",
    },
  },

  booking: {
    slug: "booking",
    name: "TRYB Booking",
    accent: "booking",
    accentColor: "hsl(150, 100%, 40%)",
    accentGlow: "rgba(0, 204, 102, 0.35)",
    liveUrl: "https://www.trybbooking.com",
    status: "coming_soon",
    icon: CalendarDays,
    statsValues: [
      { value: 24, suffix: "/7" },
      { value: 6, suffix: "+" },
      { value: 90, suffix: "%" },
      { value: 5, suffix: "" },
    ],
    featureIcons: [CalendarDays, Users, PayCard, Clock, LinkIcon, BarChart3],
    pricing: [
      { price: "—", per: "" },
      { price: "—", per: "", featured: true },
    ],
    mockups: {
      laptop:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/7umu8nrv_image.png",
      mobile:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/rwkd1qip_TRYB%20Booking.jpeg",
    },
  },

  luckywheel: {
    slug: "luckywheel",
    name: "MyLuckyWheel",
    accent: "luckywheel",
    accentColor: "hsl(320, 100%, 55%)",
    accentGlow: "rgba(255, 0, 255, 0.35)",
    liveUrl: "https://www.myluckywheel.app",
    status: "live",
    icon: PartyPopper,
    statsValues: [
      { value: 35, suffix: "%+" },
      { value: 5, suffix: "" },
      { value: 247, suffix: "+" },
      { value: 3, suffix: "" },
    ],
    featureIcons: [Trophy, Target, BarChart3, Mail, Layers, Building2],
    pricing: [
      { price: "€0", per: "/mo" },
      { price: "€9.99", per: "/mo" },
      { price: "€19.99", per: "/mo", featured: true },
      { price: "€39", per: "/mo" },
    ],
    mockups: {
      laptop:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/9arivjc2_screenshot-%5Bmyluckywheel.app%5D.webp",
      mobile:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/qtixh1z1_image.png",
    },
  },

  page: {
    slug: "page",
    name: "TRYB Page",
    accent: "page",
    accentColor: "hsl(15, 95%, 60%)",
    accentGlow: "rgba(255, 95, 47, 0.35)",
    liveUrl: "https://www.tryb.page",
    status: "live",
    icon: LinkIcon,
    statsValues: [
      { value: 141, suffix: "+" },
      { value: 437, suffix: "+" },
      { value: 37554, suffix: "+" },
      { value: 100, suffix: "%" },
    ],
    featureIcons: [Layers, LinkIcon, QrCode, BarChart3, Send, Sparkles],
    pricing: [
      { price: "€9.99", per: "/mo" },
      { price: "€29.99", per: "/mo", featured: true },
      { price: "€199.99", per: "/mo" },
    ],
    mockups: {
      laptop:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/tdye934r_screenshot-%5Btryb.page%5D.webp",
      mobile:
        "https://customer-assets.emergentagent.com/job_solutions-showcase-3/artifacts/c032rpk9_screenshot-%5Btryb.page%5D%20%281%29.webp",
    },
  },
};

export const PRODUCT_ORDER = ["loyalty", "review", "connect", "page", "booking", "luckywheel"];

export const getSiblings = (slug) =>
  PRODUCT_ORDER.filter((s) => s !== slug).map((s) => PRODUCTS[s]);
